import * as Apollo from '@apollo/react-hooks'
import { FEATURE_FLAGS_LIST_QUERY } from './gql'

interface IAppFeatureFlag {
  id: string
  enabled: boolean | null
}

// Optionally accept a schoolId so we can also read feature flags for the School actor.
export default function useAppFeatureFlags(schoolId?: number) {
  // Only send schoolId to GraphQL when we actually have one.
  // If omitted, the backend resolver falls back to the current user's school.
  const variables = schoolId != null ? { schoolId } : {}

  const { loading, data, error } = Apollo.useQuery(FEATURE_FLAGS_LIST_QUERY, {
    fetchPolicy: 'no-cache',
    variables,
  })

  if (loading || error || !data) {
    return {
      appFeatureFlagEnabled: (_ID: string) => false,
      appFeatureFlags: [],
    }
  }

  const userFlags: IAppFeatureFlag[] = (data.featureFlagsList || []) as IAppFeatureFlag[]
  const schoolFlags: IAppFeatureFlag[] = (data.school && data.school.featureFlags) || []

  const combinedFlags = [...userFlags, ...schoolFlags]

  const accBase: { [key: string]: any } = {}
  const featureFlagsLookup = combinedFlags.reduce((acc, item) => {
    if (item?.id) {
      // If any source (user or school) enables the flag, treat it as enabled.
      acc[item.id] = acc[item.id] || item.enabled
    }
    return acc
  }, accBase)

  return {
    appFeatureFlagEnabled: (id: string) => !!featureFlagsLookup[id],
    appFeatureFlags: combinedFlags,
  }
}
